module.exports = __webpack_public_path__ + "static/WEDDING E&M-393-717ed554a8e6fc945684fefc49a1f573.jpg";